__turbopack_context__.v({
  "active": "eiOlMq_active",
  "articleRow": "eiOlMq_articleRow",
  "articleRowBody": "eiOlMq_articleRowBody",
  "articleRowIcon": "eiOlMq_articleRowIcon",
  "articleRowMeta": "eiOlMq_articleRowMeta",
  "articleRowTitle": "eiOlMq_articleRowTitle",
  "backdrop": "eiOlMq_backdrop",
  "categoryChip": "eiOlMq_categoryChip",
  "categoryChipIcon": "eiOlMq_categoryChipIcon",
  "container": "eiOlMq_container",
  "dropdown": "eiOlMq_dropdown",
  "footerCta": "eiOlMq_footerCta",
  "footerCtaLabel": "eiOlMq_footerCtaLabel",
  "highlight": "eiOlMq_highlight",
  "keywordWrapper": "eiOlMq_keywordWrapper",
  "listItemDate": "eiOlMq_listItemDate",
  "listItemDescription": "eiOlMq_listItemDescription",
  "listItemInfo": "eiOlMq_listItemInfo",
  "listItemLogo": "eiOlMq_listItemLogo",
  "listItemLogoImage": "eiOlMq_listItemLogoImage",
  "listItemSubtitle": "eiOlMq_listItemSubtitle",
  "listItemTitle": "eiOlMq_listItemTitle",
  "listItemWrapper": "eiOlMq_listItemWrapper",
  "negative": "eiOlMq_negative",
  "noResultsText": "eiOlMq_noResultsText",
  "positive": "eiOlMq_positive",
  "resultListItem": "eiOlMq_resultListItem",
  "resultWrapper": "eiOlMq_resultWrapper",
  "resultsWrapper": "eiOlMq_resultsWrapper",
  "searchBackdropFadeIn": "eiOlMq_searchBackdropFadeIn",
  "sectionHeader": "eiOlMq_sectionHeader",
  "sectionHeaderCount": "eiOlMq_sectionHeaderCount",
  "sectionHeaderLabel": "eiOlMq_sectionHeaderLabel",
  "sectionTitle": "eiOlMq_sectionTitle",
  "shortDate": "eiOlMq_shortDate",
  "symbolPill": "eiOlMq_symbolPill",
  "symbolPillChange": "eiOlMq_symbolPillChange",
  "symbolPillList": "eiOlMq_symbolPillList",
  "symbolPillLogo": "eiOlMq_symbolPillLogo",
  "symbolPillPrice": "eiOlMq_symbolPillPrice",
  "symbolPillPriceSkeleton": "eiOlMq_symbolPillPriceSkeleton",
  "symbolPillShimmer": "eiOlMq_symbolPillShimmer",
  "symbolPillSkeleton": "eiOlMq_symbolPillSkeleton",
  "symbolPillTitle": "eiOlMq_symbolPillTitle",
  "symbolRow": "eiOlMq_symbolRow",
  "symbolRowBody": "eiOlMq_symbolRowBody",
  "symbolRowChangePercent": "eiOlMq_symbolRowChangePercent",
  "symbolRowExchange": "eiOlMq_symbolRowExchange",
  "symbolRowLogo": "eiOlMq_symbolRowLogo",
  "symbolRowName": "eiOlMq_symbolRowName",
  "symbolRowPrice": "eiOlMq_symbolRowPrice",
  "symbolRowTitle": "eiOlMq_symbolRowTitle",
  "trendingIcon": "eiOlMq_trendingIcon",
  "trendingKeywordItem": "eiOlMq_trendingKeywordItem",
  "wrapper": "eiOlMq_wrapper",
});
